<template>
  <v-navigation-drawer
    expand-on-hover
    permanent
    v-model="navstate"
    app
    color="manuBackground"
    width="230"
    :mini-variant.sync="mini"
    floating
  >
    <v-list>
      <img
        :src="mini ? './assets/logo-mini.svg' : './assets/Logo.svg'"
        alt="logo"
        class="mt-5 anim"
        :class="{ 'ml-2': mini, 'ml-4': !mini }"
        height="32"
        title="go to home"
        style="cursor: pointer"
        @click="gotoHome()"
      />
      <div class="mt-8" v-if="this.fordashboard == 0">
        <div class="mt-8">
          <div v-for="app in apps" :key="app.app_id">
            <v-list-item
              @click="goTo(app.app_url_withkey, app.app_id)"
              class="anim"
              :class="{ 'pl-4': mini, 'pl-6': !mini }"
              :ripple="false"
            >
              <v-list-item-icon class="mr-1 mt-3">
                <Icon
                  :name="
                    app.app_name
                      .split(' ')
                      .join('-')
                      .toLowerCase()
                  "
                />
              </v-list-item-icon>

              <v-list-item-title
                class="titleText--text text-left ml-4 font-weight-bold"
                :class="{ 'menuActive--text': app.app_id === 1 }"
                >{{ app.app_name }}
              </v-list-item-title>
            </v-list-item>

            <div v-if="app.app_id === 1 && isshow && $route.name !== 'dashboard'">
              <v-list-item
                v-for="appsubmenu in submenulist"
                :key="appsubmenu.id"
                class="anim"
                :class="{ 'pl-4': mini, 'pl-6': !mini }"
                :ripple="false"
              >
                <v-list-item-content>
                  <v-list-item-title
                    class="titleText--text text-left ml-6 font-weight-bold"
                  >
                    <span
                      :class="
                        appsubmenu.urls.includes($route.path) ? 'roundedsubmenu' : ''
                      "
                      @click="goToSubmenu(appsubmenu.urls[0], appsubmenu.children)"
                      style="cursor: pointer"
                    >
                      <span class="ml-2"> {{ appsubmenu.name }}</span></span
                    >
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="mt-8">
          <div v-for="app in apps" :key="app.app_id">
            <v-list-item
              @click="goTo(app.app_url_withkey, app.app_id)"
              class="mb-3 anim"
              :class="{ 'pl-4': mini, 'pl-6': !mini }"
              :ripple="false"
            >
              <v-list-item-icon class="mr-1 mt-3">
                <Icon
                  :name="
                    app.app_name
                      .split(' ')
                      .join('-')
                      .toLowerCase()
                  "
                />
              </v-list-item-icon>

              <v-list-item-title
                class="titleText--text text-left ml-4 font-weight-bold"
                :class="{ 'menuActive--text': app.app_id === 3 }"
                >{{ app.app_name }}
              </v-list-item-title>
            </v-list-item>
          </div>
        </div>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import Icon from "../../components/Icon";
import API from "../../apis/apifactory";
import globalval from "../../global/globalvar";
export default {
  components: {
    Icon,
  },
  props: {
    fordashboard: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      navstate: true,
      isshow: false,
      apps: [],
      mini: true,
      showChild: false,
      submenulist: [
        {
          id: 1,
          name: "Setting Project",
          urls: ["/settingproject"],
        },
        {
          id: 2,
          name: "Data Exploration",
          urls: ["/edaprocess","/edaanalysis"],
        },
        {
          id: 3,
          name: "Data Preparation",
          urls: ["/dataprocess","/sessionalitysetting", '/newvariablecreation', '/variabletransformation'],
         
        },
        {
          id: 4,
          name: "Build Model",
          urls: ["/modeldataprocess","/modeldata"],
        },
      ],
    };
  },
  methods: {
    goTo(url) {
      location.href = url;
    },

    goToSubmenu(url, children) {
      if (children) {
        this.showChild = !this.showChild
      } else {
        return this.$router.push(url);
      }
    },
    getCurrentUserApps() {
      API.getloginuserapps(this.userId)
        .then((res) => (this.apps = [...res.data]))
        .catch((error) => console.warn(error));
    },
    gotoHome() {
      let newurl =
        globalval.PARAM_GLOBAL_HOME + localStorage.getItem("SET_USERID");
      window.location.href = newurl;
    },
  },
  computed: {
    userId() {
      return localStorage.getItem("SET_USERID");
    },
  },
  mounted() {
    this.getCurrentUserApps();
  },
  watch: {
    mini(val) {
      this.isshow = !val;
    },
  },
};
</script>

<style>
.selectedtab {
  border-left-width: 5px !important;
  border-left-color: #51a7f8 !important;
  border-left-style: solid !important;
  position: relative !important;
}

.custom-list .v-list-item {
  height: 26px !important;
}

.anim {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.roundedsubmenu {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  padding: 4px 4px;

  /*gap: 10px; height: 28px;*/
  width: 100%;
  line-height: 28px;
  background: rgba(68, 164, 255, 0.14);
  border-radius: 6px;
  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  color: #51a7f8;
}
</style>
